<template>
  <div id="page-wrap">
    <div class="container">
      <div class="profile-header">
        <div
          class="profile-avator"
          :style="userInfo.avatar | styleFilter"
          id="view"
          @click="cropper2"
        >
          <div class="camera" v-if="right__publicFileUpload">
            <i class="ti-camera"></i>
          </div>
        </div>
        <div class="name">
          <span>{{ userInfo.name }}</span>
          <a data-placement="bottom" data-toggle="tooltip" title="修改资料">
            <router-link
              class="ti-pencil"
              :to="{ name: 'editpersonaInfo' }"
              tag="i"
            ></router-link>
          </a>
        </div>
        <div class="info">{{ userInfo.profile }}</div>
      </div>
      <div class="profile-num">
        <span>
          文件
          <i>·</i>
          <b>
            <router-link :to="{ name: 'recdrive' }">{{
              userInfo.user_file_count
            }}</router-link>
          </b>
        </span>
        <span>
          分享
          <i>·</i>
          <b>
            <a @click="goToMyShare">{{ userInfo.user_share_count }}</a>
          </b>
        </span>
        <span>
          群组
          <i>·</i>
          <b>
            <router-link :to="{ name: 'grouplist' }">{{
              userInfo.user_group_count
            }}</router-link>
          </b>
        </span>
      </div>
      <div class="profile-info">
        <ul>
          <li>
            <i class="ti-user"></i>
            <p>性别</p>
            <h1>{{ userInfo.gender | getGender }}</h1>
          </li>
          <li>
            <i class="ti-email"></i>
            <p>邮箱</p>
            <h1>{{ userInfo.email ? userInfo.email : "未填写" }}</h1>
          </li>
          <li>
            <i class="ti-mobile"></i>
            <p>手机</p>
            <h1>{{ userInfo.mobile ? userInfo.mobile : "未填写" }}</h1>
          </li>
        </ul>
      </div>
    </div>
    <cropper @complete2="complete2"></cropper>
  </div>
</template>

<script>
export default {
  name: "PersonaInfo",
  components: { cropper: () => import("@/views/Common/cropper2") },
  data() {
    return { imgSrc2: "" };
  },
  created() {
    this.$store.commit("SET_THEME", "个人资料");
    this.$store.dispatch("UserInfo");
  },
  filters: {
    styleFilter(value) {
      return `background: url(${value}) no-repeat 0px 0px / 100px 100px #999;`;
    },
    getGender: function (value) {
      let gender;
      switch (value) {
        case "0":
          gender = "保密";
          break;
        case "1":
          gender = "男";
          break;
        case "2":
          gender = "女";
          break;
        default:
          gender = "未填写";
          break;
      }
      return gender;
    },
  },
  methods: {
    /**
     * 跳转到我的分享
     */
    goToMyShare() {
      this.$router.push({
        name: "recdrive",
        query: {
          tab: "myshare",
        },
      });
    },
    complete2() {
      this.$store.dispatch("UserInfo");
    },
    cropper2() {
      if (this.right__publicFileUpload) {
        $("#filebtn2").click();
      }
    },
  },
  computed: {
    right__publicFileUpload () {
      return this.$store.getters.right__publicFileUpload
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    theme() {
      return this.$store.state.app.theme;
    },
  },
};
</script>

<style scoped>
</style>